"use client";
import React, { useState } from "react";
import { TopicTags } from "./../components/reviewchannel/TopicTags";
import { FilterBar } from "./../components/reviewchannel/FilterBar";
import { ReviewList } from "./../components/reviewchannel/ReviewList";
import { ReviewForm } from "./../components/reviewchannel/ReviewForm";
import TopBarSignedIn from "./../components/common/TopBarSignedIn";
import { useQuery } from "@tanstack/react-query";
import { fetchReviewChannels } from "../api/reviewChannelApi";
import { fetchReviewTags } from "../api/reviewTagApi";
import { fetchAccents } from "../api/accentApi";

export const ReviewChannel = () => {
  const [selectedTag, setSelectedTag] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [sortBy, setSortBy] = useState("votes");
  const [sortOrder, setSortOrder] = useState("desc");

  const {
    data: reviewChannels,
    error: errorreviewChannel,
    isLoading: isLoadingreviewChannel,
  } = useQuery({
    queryKey: ["reviewchannel"], // Include topicId to refetch when it changes
    queryFn: fetchReviewChannels, // ✅ Pass function reference
  });
  const {
    data: reviewTags,
    error: errorreviewTag,
    isLoading: isLoadingreviewTag,
  } = useQuery({
    queryKey: ["reviewtag"], // Include topicId to refetch when it changes
    queryFn: fetchReviewTags, // ✅ Pass function reference
  });

  const {
    data: accents,
    error: errorreviewAccent,
    isLoading: isLoadingreviewAccent,
  } = useQuery({
    queryKey: ["accent"], // Include topicId to refetch when it changes
    queryFn: fetchAccents, // ✅ Pass function reference
  });

  const handleAddReview = (newReview) => {
    // const reviewWithId = {
    //   ...newReview,
    //   id: `${reviews.length + 1}`,
    //   topic: TOPICS.find((t) => t.id === newReview.topicId).name,
    //   reviewer: "CurrentUser", // In a real app, this would be the logged-in user
    // };

    // setReviews([reviewWithId, ...reviews]);
    // setShowForm(false);
  };

  const handleSortChange = (field, order) => {
    setSortBy(field);
    setSortOrder(order);
  };

  return (
    <div className="w-full bg-white min-h-screen">
      <TopBarSignedIn />
      <main className="flex flex-col gap-6 p-6 mx-auto w-full max-w-[1272px] max-sm:px-4">
        <header className="mb-8">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Danh sách các kênh Youtube dành cho con
          </h1>
          <p className="text-gray-600">
            Trên cơ sở là người hiểu con nhất, quý phụ huynh hãy lựa chọn các kênh phù hợp cho con xem nhé!
          </p>
        </header>

        {
          reviewTags && <TopicTags
            topics={reviewTags}
            selectedTag={selectedTag}
            onSelectTag={setSelectedTag}
          />
        }

        <div className="flex flex-wrap justify-between items-center mb-6">
          <FilterBar
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSortChange={handleSortChange}
          />

          <button
            onClick={() => setShowForm(!showForm)}
            className="px-4 py-2 text-sm font-medium text-white bg-rose-700 rounded-lg hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-rose-300"
          >
            {showForm ? "Cancel" : "Create Review"}
          </button>
        </div>

        {showForm && (
          <ReviewForm
            reviewtags={reviewTags}
            accents={accents}
            onSubmit={handleAddReview}
            onCancel={() => setShowForm(false)}
          />
        )}

        {
          reviewChannels && <ReviewList
            reviews={reviewChannels}
            selectedTag={selectedTag}
            searchTerm={searchTerm}
          />
        }
      </main>
    </div>
  );
};

export default ReviewChannel;
